<template>
  <footer class="personal-footer">
    <div class="row border-top mx-0 py-2">
      <div class="col copyright footer-text text-left">
        &copy; {{ year }}
        <span>LotePerfecto. Una empresa de Avaluna SRL</span>
      </div>
      <div class="col contact-mail footer-text text-right">
        <a href="mailto:info@loteperfecto.com">info@loteperfecto.com</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>